(function ($, Global) {
    var timer;

	var CarteComponent = function (model) {
		this.model = model;
	}

	CarteComponent.prototype.initEvents = function () {
		this.publishers();
		this.subscribers();
	}

	CarteComponent.prototype.publishers = function () {
		var self = this;
		var CarteDossierImage = $('.ZoneCarte').attr('data-carteImageFolder');
		var CarteLangue = $('.ZoneCarte').attr('data-carteLangue');
		var CartePubli = $('.ZoneCarte').attr('data-cartePubli');

		$(document).ready(function () {
			var data = {};

			data['lang'] = CarteLangue;
			data['Country'] = Global.CARTE_PAYS_SELECTIONNE_PAR_DEFAUT;
            data['CountrySelected'] = Global.CARTE_PAYS_SELECTIONNE_PAR_DEFAUT;
			data['Publication'] = Global.CARTE_PUBLI_SELECTIONNE_PAR_DEFAUT;
			data['Free'] = Global.CARTE_MODE_GRATUIT;

			changeSelectCountry(CarteDossierImage, data);
		});

		$('.Carte_Zone').mouseover(function () {
			var nomPays = $(this).attr('id');
            var modifNomPays = $(this).attr('alt');
			var $divImage = $('.ZoneCarte .Carte .Pays.' + nomPays + ' .IconPays');
			
			if (Global.listeRemplacementPays) {
				$.each(listeRemplacementPays, function (i, v) {
                    if (v.nom.toUpperCase() == nomPays.toUpperCase()) {
                        nomPays = v.valeur;
					}
				});
			}

			updateImagePays(CarteDossierImage, $divImage, true);
	
			$('.ZoneCarte .PaysSelectionnee').html(modifNomPays).show();
		});

		$('.Carte_Zone').mouseout(function () {
			var nomPays = $(this).attr('id');
			var $divImage = $('.ZoneCarte .Carte .Pays.' + nomPays + ' .IconPays');

			$('.ZoneCarte .PaysSelectionnee').hide();
			
			if (nomPays != Global.CARTE_PAYS_SELECTIONE) {				
				updateImagePays(CarteDossierImage, $divImage, false);
			}
		});

        $('.Carte_Zone').click(function () {
            if (timer) {
                clearTimeout(timer);
            }
            var $this = $(this);
            var data = {};

            timer = setTimeout(function () {
                data['lang'] = CarteLangue;
                data['Country'] = $this.attr('alt');
                data['CountrySelected'] = $this.attr('id');
                data['Publication'] = CartePubli;
                data['Free'] = Global.CARTE_MODE_GRATUIT;

                changeSelectCountry(CarteDossierImage, data);
            }, 500)			
		});

		$(document).on('change', '.Carte_Filters [name="optionsArticlesFilter"]', function (e) {
			var $this = $(this);
			var data = {};

			if ($this.val() == 'all') {
				Global.CARTE_MODE_GRATUIT = false;
			}
			else if ($this.val() == 'free') {
				Global.CARTE_MODE_GRATUIT = true;
			}
			else if ($this.val() == 'abo') {
				Global.CARTE_MODE_GRATUIT = false;

				data['Subscription'] = true;
			}
			else if ($this.val() == 'publi') {
				Global.CARTE_MODE_GRATUIT = false;
				data['Publication'] = $('.Carte_Filters .select-publi').val();
			}

			data['lang'] = CarteLangue;
			data['Country'] = Global.CARTE_PAYS_SELECTIONE;
			data['Publication'] = data['Publication'] || CartePubli;
			data['Free'] = Global.CARTE_MODE_GRATUIT;

			$.Topic('load-country').publish(data);
		});

		$(document).on('change', '.Carte_Filters .select-publi', function () {
			$(this).parent().find('input').checked(true).trigger('change');
		});

		$('.ZoneCarte .BlocPays')
			.viewport({ max: Global.viewports.md - 1 }, function () {
				if ($('.ZoneCarte .Info .BlocPays').exists()) {
					$(this).insertAfter('.ZoneCarte .Carte_container');
				}
			})
			.viewport({ min: Global.viewports.md }, function () {
				if (!$('.ZoneCarte .Info .BlocPays').exists()) {
					$(this).appendTo('.ZoneCarte .Info');
				}
			});
	}

	CarteComponent.prototype.subscribers = function () {
		var self = this;

		$.Topic('load-country').subscribe(function (data) {
			var loadingText = data['lang'] == 'FRA' ? 'Chargement en cours ...' : 'Loading...';

			$('#Carte_ArticlePays').html(
				'<div class="Carte_LoaderPays"><img src="/img/gen/ajax-loader.gif" alt="Loading" />&#160;&#160;' + loadingText + '</div>'
			);

			self.model.getCountry(data, function (data) {
				$('#Carte_ArticlePays').html(data.data.html);
			});
		});
	}

    function changeSelectCountry($carteDossierImage, data) {
        if (data['CountrySelected'] != '') {
            var $divImage = $('.ZoneCarte .Carte .Pays.' + data['CountrySelected'] + ' .IconPays');

            CARTE_PAYS_SELECTIONE = data['CountrySelected'];
            $('.ZoneCarte .Carte .Pays .IconPays').each(function (interger, element) {
                $(element).attr('class', $(element).attr('class').replace($carteDossierImage, 'Available'));
            });

            updateImagePays($carteDossierImage, $divImage, true);

            $.Topic('load-country').publish(data);
        }
		
	}

	function updateImagePays($carteDossierImage, $image, isSelected) {
		if ($image.exists()) {
			var baseImage = $image.attr('class');
			var nouvelleImage = (isSelected) ?
				baseImage.replace('Available', $carteDossierImage) :
				baseImage.replace($carteDossierImage, 'Available');	

			$image.attr('class', nouvelleImage);
		}
	}

	Global.CarteComponent = CarteComponent;
}(jQuery, window));